import { IMAGE_CACHE_NAME } from '../contants';
export class WebImageCacheAdapter {
    async isSupported() {
        return typeof caches !== 'undefined';
    }
    async cacheImage(url) {
        try {
            // const cache = await caches.open(IMAGE_CACHE_NAME);
            const response = await fetch(url);
            if (!response.ok)
                throw new Error(`Failed to fetch image: ${response.status}`);
            // await cache.put(url, response.clone());
            return true;
        }
        catch (error) {
            console.error('Failed to cache image:', error);
            return false;
        }
    }
    async cacheImages(urls) {
        const results = {};
        await Promise.all(urls.map(async (url) => {
            results[url] = await this.cacheImage(url);
        }));
        return results;
    }
    async isCached(url) {
        try {
            const cache = await caches.open(IMAGE_CACHE_NAME);
            const response = await cache.match(url);
            return !!response;
        }
        catch (error) {
            console.error('Failed to check cache status:', error);
            return false;
        }
    }
    async clearCache() {
        try {
            await caches.delete(IMAGE_CACHE_NAME);
        }
        catch (error) {
            console.error('Failed to clear cache:', error);
        }
    }
    async uncacheImage(url) {
        try {
            const cache = await caches.open(IMAGE_CACHE_NAME);
            const result = await cache.delete(url);
            return result;
        }
        catch (error) {
            console.error('Failed to uncache image:', error);
            return false;
        }
    }
}
